import React from 'react';
export function Gallery() {
  const images = ['https://images.unsplash.com/photo-1572331165267-854da2b10ccc?auto=format&fit=crop&q=80&w=800', 'https://images.unsplash.com/photo-1571003123894-1f0594d2b5d9?auto=format&fit=crop&q=80&w=800', 'https://images.unsplash.com/photo-1613553507747-5f8d62ad5904?auto=format&fit=crop&q=80&w=800', 'https://images.unsplash.com/photo-1568932901444-29c47b9f5be3?auto=format&fit=crop&q=80&w=800'];
  return <section id="gallery" className="py-24 bg-slate-900" data-id="element-125">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-126">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-6" data-id="element-127">
          <div className="max-w-2xl" data-id="element-128">
            <h2 className="text-blue-400 font-bold tracking-wide uppercase text-sm mb-3" data-id="element-129">
              Our Work
            </h2>
            <h3 className="text-3xl md:text-4xl font-extrabold text-white" data-id="element-130">
              Arizona backyards, maintained to perfection.
            </h3>
          </div>
          <button onClick={() => document.getElementById('contact')?.scrollIntoView({
          behavior: 'smooth'
        })} className="bg-white/10 hover:bg-white/20 text-white px-6 py-3 rounded-full font-medium transition-colors backdrop-blur-sm border border-white/10 shrink-0" data-id="element-131">
            Get a Free Quote
          </button>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-132">
          {images.map((src, idx) => <div key={idx} className="group relative aspect-[4/3] overflow-hidden rounded-2xl bg-slate-800" data-id="element-133">
              <img src={src} alt="Maintained pool" className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-134" />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-135" />
            </div>)}
        </div>
      </div>
    </section>;
}